import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';
import { CSSProperties, FC } from 'react';

import FoetexIcon from '@/assets/logos/icon_foetex.svg?react';
import { BrandIconProps } from '@/components/shared/logos/props';

const DEFAULT_PRIMARY_COLOR = '#0F223B';

const BrandIconFoetex: FC<BrandIconProps> = ({
  themeAware = true,
  primaryColor,
  ...other
}) => {
  const theme = useTheme();

  let fontColor = 'white';
  let borderColor = DEFAULT_PRIMARY_COLOR;
  let backgroundColor = primaryColor ?? DEFAULT_PRIMARY_COLOR;

  if (themeAware && !primaryColor && theme.palette.mode === 'dark') {
    backgroundColor = 'transparent';
    borderColor = 'white';
    fontColor = primaryColor ?? 'white';
  }

  return (
    <SvgIcon {...other}>
      <FoetexIcon
        style={
          {
            '--background-color': backgroundColor,
            '--border-color': borderColor,
            '--font-color': fontColor,
          } as CSSProperties
        }
      />
    </SvgIcon>
  );
};

export default BrandIconFoetex;
